import React, { Component } from 'react';
import { connect } from 'react-redux';
import "react-datepicker/dist/react-datepicker.css";
import Drag from './dragNdDrop';
import { ANY_ERROR } from '../../action/user_action_types';
import http from '../../util/http';
import { endPoints, url } from '../../config';


class ExcelPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: null,          
      uploadAudio: null,
      uploadedAudio: undefined,
      AudioDuration: undefined,    
      FileSize: undefined,
      fileSizeWithLimit: undefined,
      bytesToSize: '',
      option: true
    }
  }
 

  // handlefileName = fileName => { 
  //   console.log("fileNamefileNamefileName",fileName);   
  //   this.setState({ fileName });
  // }

  handlefileName=event=>{
    console.log(event);
    this.setState({
      fileName: event.target.value,
      // loaded: 0,
    })
  }



  //Handling the files
  // handleuploadedAudio = event => {
  //   let { name, files } = event.target;
  //   let { uploadAudio } = this.state;   
  //   if (index == -1) {
  //     uploadAudio.push(name);
  //   }
  //   this.setState({     
  //     uploadAudio:files,     
  //   });
  // }

  //  //Upload a file
  //  getUploadedFileaudio= files=> {
  //   this.setState({uploadAudio: files });
  // }

  getUploadedFileaudio=event=>{
    console.log('getUploadedFileaudiogetUploadedFileaudio',event);
    // handleuploadedAudio(files);
    this.setState({
      uploadAudio: event.target,
      // uploadedAudio: event.target,      
    })
  }

       //Remove file
       removeFile= event => {
        console.log(event);
        this.setState({
          uploadAudio: null     
        });
      }

  

  // //Upload a file
  // getUploadedFileaudio = files => {
  //   console.log("Audio File>>>",files);
  //   var size = bytesToSize(files.size);
  //   // console.log(size);
  //   setFileSizeWithLimit(size);
  //   getAudioDuration(files);
  //   handleuploadedAudio(files);
  //   handleFileName(files.name);
  //   handleFileSize(files.size);
  // }

  

  // Show file size in bytes
   bytesToSize = (bytes, decimals=2) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if(bytes == 0) return '0 bytes';
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed())+ ' ' + sizes[i];
  }

    // //Updating the kyc details
    // uploadaudioalone = () => {      
    // let { uploadAudio, uploadedAudio, FileSize, fileName , AudioDuration } = this.state;
    // this.props.uploadaudioalone(endPoints.uploadaudioalone);
    // }

    uploadaudioalone = async params => {
      console.log(params);
    try {
      const data = await Axios.post(endPoints.uploadaudioalone,params);
      const result = data.data.data.data;      
    } catch (error) {
      console.log(error);
    }
  }


   
 
  render() {
    let { fileName,uploadAudio,uploadedAudio,AudioDuration,FileSize, bytesToSize} = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modalaudio">
              <div className="modal-head-cross rate-modal">
                <button type="button" className="modal-close-button" onClick={() => this.props.hideExcelPopup()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                 <div className="editNonFct-header modal-header" >
                <h4 className="popup-head rqst-head fct-head modal-title">________________________________________    UPLOAD AUDIO    ____________________________________</h4></div>
                <div className="editNonFct-modal modal-body">
                 <div className="bg-white">
                  <form className="form-group">
                      <div className="popupCampaign-container">  
                                                 
                         <div className="field_wrapper margin0"> 
                          <h6 className="camp_label">Audio name</h6>
                          <input type="text"  onChange={this.handlefileName}  
                          placeholder="Enter Audio name" />
                        </div>
                        
                        {/* && this.option && 
                        <div className={this.uploadAudio} > */}


                         <div className="field_wrapper margin0">  
                          <h6>Upload Audio File</h6>
                          {!this.uploadedAudio  && <div className="upload_file" >
                            <input type="file" name="file"
                          // <Drag
                           getUploadedFile={this.getUploadedFileaudio}  accept=".mp3" />  
                          <div className="file_size">Size of audio file should be less than 5MB. Only mp3 files are supported</div>
                          </div>     
                         }

                        {/* {this.uploadedAudio && this.option && <div className="upload_file"> */}

                        {/* <div className="field_wrapper margin0"> 
                          <h6>Uploaded audio File</h6>
                          {this.uploadedAudio && <div className="upload_file" > 
                            <div className="audio_img"> <img src="../../assets/images/song.svg" /></div>
                            <div className="file_desc">
                             <div className="file_name_size">
                             <div className="file_name">{this.uploadedAudio.path}</div>                               
                              </div>
                              <div className="remove_file"><span className="filesize"></span><a onClick={this.removeFile}> REMOVE</a></div>
                            </div>
                          </div>}
                          </div> */}
                        {/* </div>} */}
                        </div>
                     

                       <div className="cost_button">
                       <button className="cncl" >CANCEL</button>
                       <button className="procd" onClick={this.uploadaudioalone}>Upload</button>                       
                      </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {

    uploadaudioalone: (url, data, path) => dispatch(postServerDataWithPath(url, data, path)),

    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    })
  }
}

export default connect(null, mapDispatchToProps)(ExcelPopup);



// WEBPACK FOOTER //
// ./web/components/audioManagement/ExcelPopup.jsx